
export function updateCredits(value) {
  const el = window.document.getElementById('kreditai_skaicius')
  if (el != null) {
    el.innerHTML = value
  }
}
